// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7bqU6","colMin":"styles_colMin__2ihDN"};